<script lang="ts">
  import { push } from "svelte-spa-router";
  import { track } from "../../helpers/mixpanel";
  import { link } from "svelte-spa-router";
  import { resetStore } from "../../helpers/store";
  import StatementAddresses from "../StatementAddresses.svelte";
  import { hasMinPremiumSubscription } from "../../helpers/subscription";
  import { createGetSubscriptionQuery } from "../../queries/subscriptions";
  import { STRIPE_CUSTOMER_PORTAL_URL } from "../../helpers/constants";
  import TextNew from "../TextNew.svelte";
  import { uiSettings } from "../../stores/ui-settings";
  import { AUTOFORWARD_INVOICES_EMAIL } from "../../constants/email";
  import { selectedBuyer } from "../../stores/buyer";

  function logOut() {
    track("settings_logout_click");
    resetStore();
    uiSettings.clear();
    push("/");
  }

  $: buyerID = $selectedBuyer?.id ?? "";
  $: invoiceForwardingEmails =
    $selectedBuyer?.invoice_forwarding_emails?.join(", ") || AUTOFORWARD_INVOICES_EMAIL;
  $: subscriptionQuery = createGetSubscriptionQuery(buyerID);
  $: hasPremium =
    $subscriptionQuery.data != null &&
    hasMinPremiumSubscription($subscriptionQuery.data.plan, $subscriptionQuery.data.status);

  function copyInvoiceEmail() {
    navigator.clipboard.writeText(invoiceForwardingEmails);
    track("settings_upload_email_address_click");
  }
</script>

<div class="container">
  {#if $selectedBuyer}
    <!-- Follow up on this with Zoe?
      This is pretty fugly, and the auto-fwd copy + copy to clipboard functionality doesn't make sense
    -->
    <button on:click={copyInvoiceEmail} class="invoice-email-btn">
      <TextNew size="s" as="span" --rk-text-color="var(--rekki-neutral-04)">
        {"auto forward invoices to:\n"}
      </TextNew>
      <TextNew size="s" as="span" weight="medium" --rk-text-color="var(--rekki-neutral-04)">
        {invoiceForwardingEmails}
      </TextNew>
    </button>
  {/if}

  {#if hasPremium}
    <a
      class="mlink"
      href={STRIPE_CUSTOMER_PORTAL_URL}
      on:click={() => {
        track("settings_manage_subscription_click");
      }}
      target="_blank"
      rel="noreferrer">manage subscription</a
    >
  {/if}

  {#if $selectedBuyer}
    <StatementAddresses buyerId={$selectedBuyer.id} />
  {/if}

  <a
    class="mlink"
    href="https://rekki.my.site.com/help/s/topic/0TO4J000000hN3jWAE/insights"
    target="_blank"
    on:click={() => {
      track("settings_help_centre_click");
    }}
    rel="noreferrer"
  >
    help center
  </a>

  <button class="mlink" on:click={logOut}>log out</button>

  <div class="footer">
    <a
      class="flink"
      href="https://tandc.rekki.com/REKKI%20BUYER%20LICENSE%20AGREEMENT.pdf"
      target="_blank"
      on:click={() => {
        track("settings_tandcs_click");
      }}
      rel="noreferrer"
    >
      T&Cs
    </a>
    <a
      class="flink"
      href="https://tandc.rekki.com/REKKI%20PRIVACY%20POLICY.pdf"
      target="_blank"
      rel="noreferrer"
      on:click={() => {
        track("settings_privacy_policy_click");
      }}
    >
      privacy
    </a>
    <a
      class="flink"
      href="/contact-us"
      use:link
      on:click={() => {
        track("settings_contact_us_click");
      }}
    >
      contact us
    </a>
  </div>
</div>

<style>
  .container {
    min-width: 264px;
    padding: 4px;
  }

  .invoice-email-btn {
    display: block;
    white-space: pre-line;
    padding: 4px 12px;
    border-radius: var(--rk-rounding-s);
  }

  .invoice-email-btn:hover {
    color: var(--rekki-dark);
    background: var(--rekki-neutral-01);
  }

  button {
    background: none;
    margin: 0;
    padding: 0;
    outline: none;
    border: none;
    width: 100%;
    text-align: left;
  }

  .mlink {
    font-size: 16px;
    line-height: 48px;
    padding: 4px 12px;
    color: var(--rekki-neutral-04);
    display: block;
    text-decoration: none;
    border-radius: var(--rk-rounding-s);
  }
  .mlink:hover {
    color: var(--rekki-dark);
    background: var(--rekki-neutral-01);
  }

  .footer {
    border-top: 1px solid var(--rekki-neutral-01);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 14px 4px 10px 4px;
    border-top: 1px solid var(--rekki-neutral-01);
    margin-top: 4px;
  }
  .flink {
    font-size: 13px;
    text-decoration: none;
    color: var(--rekki-neutral-03);
  }
  .flink:hover {
    text-decoration: underline;
  }
</style>
